import React, { forwardRef } from 'react';

import type { InternalPasswordFieldProps } from './TextField';
import { InternalTextField } from './TextField';

export type PasswordFieldProps = Omit<
  InternalPasswordFieldProps,
  'type' | 'inputType' | 'smallPadding' | 'mediumPadding' | 'largePadding' | 'verticalAlign'
>;

const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  function TextField(props, ref) {
    return (
      <InternalTextField
        ref={ref}
        type="input"
        inputType="password"
        smallPadding={0.5}
        mediumPadding={7}
        largePadding={11}
        {...props}
      />
    );
  },
);

export default PasswordField;
